//生命周期，切换后台及切回来
class lifecycleManager {
    constructor(init,resume, pause) {
        if (typeof init != "function" ||typeof resume != "function" || typeof pause != "function") {
            return;
        }
        init();
        let handleVisibilityChange = () => {
            if (!document[hidden]) {
                resume();
            } else {
                pause();
            }
        }

        //window.addEventListener("focus", resume, false);
        //window.addEventListener("blur", pause, false);

        let hidden, visibilityChange;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document["mozHidden"] !== "undefined") {
            hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
        } else if (typeof document["msHidden"] !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document["webkitHidden"] !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        } else if (typeof document["oHidden"] !== "undefined") {
            hidden = "oHidden";
            visibilityChange = "ovisibilitychange";
        }
        if ("onpageshow" in window && "onpagehide" in window) {
            window.addEventListener("pageshow", resume, false);
            window.addEventListener("pagehide", pause, false);
        }
        if (hidden && visibilityChange) {
            document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }

        let ua = navigator.userAgent;
        let isWX = /micromessenger/gi.test(ua);
        let isQQBrowser = /mqq/ig.test(ua);
        let isQQ = /mobile.*qq/gi.test(ua);

        if (isQQ || isWX) {
            isQQBrowser = false;
        }
        if (isQQBrowser) {
            let browser = window["browser"] || {};
            browser.execWebFn = browser.execWebFn || {};
            browser.execWebFn.postX5GamePlayerMessage = function(event) {
                let eventType = event.type;
                if (eventType == "app_enter_background") {
                    pause();
                } else if (eventType == "app_enter_foreground") {
                    resume();
                }
            };
            window["browser"] = browser;
        }
    }
}
export default lifecycleManager;